import {
    validateContractId,
    validateEmail,
    validatePhone,
    validatePostcode,
    validateServiceId,
    validateTeamId,
    validateUniqueIdentifier
} from '../../../utils/formValidation/validationFunctions';
import {
    validateFirstName,
    validateLastName,
    validateMiddleName,
    validatePreferredName,
    validateReferralDate
} from '../validation/validationFunctions';

export const validate = (newEntry) => {
    let newErrors = {};

    newErrors = validateContractId(newEntry.contractId, newErrors);
    newErrors = validateServiceId(newEntry.serviceId, newErrors);
    newErrors = validateTeamId(newEntry.teamId, newErrors);

    newErrors = validateReferralDate(newEntry.referralDate, newErrors);
    newErrors = validateFirstName(newEntry.firstName, newErrors);
    newErrors = validateMiddleName(newEntry.middleName, newErrors);
    newErrors = validateLastName(newEntry.lastName, newErrors);
    newErrors = validatePreferredName(newEntry.preferredName, newErrors);
    newErrors = validatePostcode(newEntry.postcode, newErrors);

    newErrors = validatePhone(newEntry.primaryPhoneNumber, newErrors, 'primaryPhoneNumber');
    newErrors = validateEmail(newEntry.emailAddress, newErrors);

    if (newEntry.contractId) {
        newErrors = validateUniqueIdentifier(
            newEntry.uniqueIdentifierType,
            newEntry.uniqueIdentifier,
            newEntry.repeatUniqueIdentifier,
            newErrors
        );
    }

    return newErrors;
};
